import React from 'react';

class FIPercBox extends React.Component {

	render() {

		var size = this.props.size || {
			width: 'auto',
			height: 'auto'
		};

		var logodisplay = ((this.props.logo.toLowerCase().indexOf('.png')  > -1 || this.props.logo.toLowerCase().indexOf('.svg') > -1 || 
				this.props.logo.toLowerCase().indexOf('.jpg') > -1) && this.props.logo.indexOf('https://yodlee-1.hs.llnwd.net/v1/LOGO/LOGO_Default.SVG') === -1 ) ? (<img src={this.props.logo} alt='FI  Logo' />) : (<div className='Logo-Label'>{this.props.bank_label}</div>);

		if(this.props.rtn.indexOf('072403046') > -1) {
			logodisplay = (<img src={process.env.PUBLIC_URL + "images/lakestone.png"} alt='FI  Logo' />);
		}
		else if(this.props.rtn.indexOf('072407741') > -1) {
			logodisplay = (<img src={process.env.PUBLIC_URL + "images/bankmichigan.png"} alt='FI  Logo' />);
		}
		else if(this.props.rtn.indexOf('272485385') > -1) {
			logodisplay = (<img src={process.env.PUBLIC_URL + "images/4frontcu.png"} alt='FI Logo' />);
		}
		else if(this.props.rtn.indexOf('081009428') > -1) {
			logodisplay = (<img src={process.env.PUBLIC_URL + "images/firstbank.png"} alt = 'FI Logo' />);
		}
		
		const currentOrNon = (window._fiSponsor.isSponsor(this.props.rtn)) ? 'current' : 'non';
		return (
			<div alt={this.props.bank_label} className='FIPercBox' style={{width: size.width, height: size.height}}>
				<div className={'FIPercBox-Perc ' + currentOrNon}>{this.props.perc}</div>
				<div className='FIPercBox-Logo'>{logodisplay}</div>
			</div>
			);
	}
}


export default FIPercBox;